import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class EmailService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  listAccount(query?: any) {
    return this.get('/v2/email/accounts', query);
  }

  createAccount(body: any) {
    return this.post('/v2/email/account', body);
  }

  findAccount(id) {
    return this.get('/v2/email/account/' + id);
  }

  updateAccount(id, body) {
    return this.put('/v2/email/account/' + id, body);
  }

  deleteAccount(id) {
    return this.delete('/v2/email/account/' + id);
  }

  listTemplate(query?: any) {
    return this.get('/v2/email/templates', query);
  }

  createTemplate(body: any) {
    return this.post('/v2/email/template', body);
  }

  findTemplate(id) {
    return this.get('/v2/email/template/' + id);
  }

  updateTemplate(id, body) {
    return this.put('/v2/email/template/' + id, body);
  }

  deleteTemplate(id) {
    return this.delete('/v2/email/template/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Email.service.ts